import deepThumb1 from "../../assets/images/productPage/product-bottle.png";
import deepThumb2 from "../../assets/images/productPage/product-bottle1.png";
import deepThumb3 from "../../assets/images/productPage/product-bottle2.png";
import deepThumb4 from "../../assets/images/productPage/product-bottle3.png";
import deepThumb5 from "../../assets/images/productPage/product-bottle4.png";
import deepThumb6 from "../../assets/images/productPage/product-bottle5.png";

import sleekThumb1 from "../../assets/images/productPage/thumbProduct2.png";
import sleekThumb2 from "../../assets/images/productPage/thumb1Product2.png";
import sleekThumb3 from "../../assets/images/productPage/thumb3Product2.png";
import sleekThumb4 from "../../assets/images/productPage/thumb2Product2.png";
import sleekThumb5 from "../../assets/images/productPage/thumb4Product2.png";
import sleekThumb6 from "../../assets/images/productPage/thumb5Product2.png";

export const deepItems = [
  {
    id: 1,
    thumb: deepThumb1,
    title1: "ウォーターコートシャンプー",
    title2: "ディープモイスト",
    price: "1,540",
    volume: "450mL",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my201/",
      q10: "https://www.qoo10.jp/g/1136127959",
      shopify: "https://shop.beaute-de-mode.jp/products/my201",
      amazon: "https://www.amazon.co.jp/dp/B0DZM3HBYJ",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my201.html",
    },
  },
  {
    id: 2,
    thumb: deepThumb2,
    title1: "ウォーターコートトリートメント",
    title2: "ディープモイスト",
    price: "1,540",
    volume: "450g",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my202/",
      q10: "https://www.qoo10.jp/g/1136130069",
      shopify: "https://shop.beaute-de-mode.jp/products/my202",
      amazon: "https://www.amazon.co.jp/dp/B0DZHJYDXP",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my202.html",
    },
  },
  {
    id: 3,
    thumb: deepThumb3,
    title1: "ウォーターコートヘアオイル",
    title2: "ディープモイスト",
    price: "1,540",
    volume: "100mL",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my206/",
      q10: "https://www.qoo10.jp/g/1136134847",
      shopify: "https://shop.beaute-de-mode.jp/products/my206",
      amazon: "https://www.amazon.co.jp/dp/B0DZHJPZQS",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my206.html",
    },
  },
  {
    id: 4,
    thumb: deepThumb4,
    title1: "ウォーターコートヘアミルク",
    title2: "ディープモイスト",
    price: "1,540",
    volume: "150g",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my208/",
      q10: "https://www.qoo10.jp/g/1136134091",
      shopify: "https://shop.beaute-de-mode.jp/products/my208",
      amazon: "https://www.amazon.co.jp/dp/B0DZHNMG6G",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my208.html",
    },
  },
  {
    id: 5,
    thumb: deepThumb5,
    title1: "ウォーターコートシャンプー",
    title2: "詰替 ディープモイスト",
    price: "1,210",
    volume: "380mL",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my203/",
      q10: "https://www.qoo10.jp/g/1136130929",
      shopify: "https://shop.beaute-de-mode.jp/products/my203",
      amazon: "https://www.amazon.co.jp/dp/B0DZMRNN78",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my203.html",
    },
  },
  {
    id: 6,
    thumb: deepThumb6,
    title1: "ウォーターコートトリートメント",
    title2: "詰替 ディープモイスト",
    price: "1,210",
    volume: "380g",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my204/",
      q10: "https://www.qoo10.jp/g/1136132448",
      shopify: "https://shop.beaute-de-mode.jp/products/my204",
      amazon: "https://www.amazon.co.jp/dp/B0DZHMJZQ6",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my204.html",
    },
  },
];

export const sleekItems = [
  {
    id: 1,
    thumb: sleekThumb1,
    title1: "ウォーターコートシャンプー",
    title2: "スリークモイスト",
    price: "1,540",
    volume: "450mL",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my101/",
      q10: "https://www.qoo10.jp/g/1135006110",
      shopify: "https://shop.beaute-de-mode.jp/products/my101",
      amazon: "https://www.amazon.co.jp/dp/B0DZM15VP3",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my101.html",
    },
  },
  {
    id: 2,
    thumb: sleekThumb2,
    title1: "ウォーターコートトリートメント",
    title2: "スリークモイスト",
    price: "1,540",
    volume: "450g",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my102/",
      q10: "https://www.qoo10.jp/g/1136136503",
      shopify: "https://shop.beaute-de-mode.jp/products/my102",
      amazon: "https://www.amazon.co.jp/dp/B0DZHKM7CF",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my102.html",
    },
  },
  {
    id: 3,
    thumb: sleekThumb3,
    title1: "ウォーターコートヘアオイル",
    title2: "スリークモイスト",
    price: "1,540",
    volume: "100mL",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my106/",
      q10: "https://www.qoo10.jp/g/1136140589",
      shopify: "https://shop.beaute-de-mode.jp/products/my106",
      amazon: "https://www.amazon.co.jp/dp/B0DZHKL3MJ",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my106.html",
    },
  },
  {
    id: 4,
    thumb: sleekThumb4,
    title1: "ウォーターコートヘアミルク",
    title2: "スリークモイスト",
    price: "1,540",
    volume: "150g",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my108/",
      q10: "https://www.qoo10.jp/g/1136138783",
      shopify: "https://shop.beaute-de-mode.jp/products/my108",
      amazon: "https://www.amazon.co.jp/dp/B0DZHHGWGD",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my108.html",
    },
  },
  {
    id: 5,
    thumb: sleekThumb5,
    title1: "ウォーターコートシャンプー",
    title2: "詰替 スリークモイスト",
    price: "1,210",
    volume: "380mL",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my103/",
      q10: "https://www.qoo10.jp/g/1136137046",
      shopify: "https://shop.beaute-de-mode.jp/products/my103",
      amazon: "https://www.amazon.co.jp/dp/B0DZMNJNZC",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my103.html",
    },
  },
  {
    id: 6,
    thumb: sleekThumb6,
    title1: "ウォーターコートトリートメント",
    title2: "詰替 スリークモイスト",
    price: "1,210",
    volume: "380g",
    ecLink: {
      rakuten: "https://item.rakuten.co.jp/joiedebeaute/my104/",
      q10: "https://www.qoo10.jp/g/1136138157",
      shopify: "https://shop.beaute-de-mode.jp/products/my104",
      amazon: "https://www.amazon.co.jp/dp/B0DZHJ5FN7",
      yahoo: "https://store.shopping.yahoo.co.jp/beautedemode/my104.html",
    },
  },
];

